import { Button, Checkbox, FormControlLabel, Grid, Radio, RadioGroup, Typography, withStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import SampleTextField from '../../CommonScreens/sampleTextField';
import TextSignature from './TextSignature';
import SignScroll from './SignScroll';
import customStyle from "../../../Assets/CSS/stylesheet_UHS";
import axios from "axios";
import configurations from "../../../configurations";
import html2canvas from "html2canvas";
import ShimmerDashboard from '../../../Assets/Loaders/ShimmerEffect';

const PurpleRadio = withStyles(customStyle.radioBtn)((props) => (
    <Radio color="default" {...props} />
));

const NextButton = withStyles(
    customStyle.doneBtn
)(Button);

const SignForm = ({ empDetails, setIsAcknowledged, setLoaderShow }) => {
    const child = React.createRef();
    const [checkBoxFirst, setCheckBoxFirst] = useState(false);
    const [checkBoxSecond, setCheckBoxSecond] = useState(false);
    const [pdfLink, setPdfLink] = useState("");
    const [isValidFullName, setIsValidFullName] = useState(false);
    const [fullName, setFullName] = useState("");
    const [signType, setSignType] = useState("stylized");
    const [canvasChanged, setCanvasChanged] = useState(false);
    const [disableAuthSubmit, setDisableAuthSubmit] = useState(true);
    const [canvasDone, setCanvasDone] = useState(false);
    const [imgUrl, setImgUrl] = useState("");

    const checkAuthEnable = () => {
        if (checkBoxFirst && checkBoxSecond && (fullName != '' || canvasDone)) {
            setDisableAuthSubmit(false);
        } else {
            setDisableAuthSubmit(true);
        }
    }

    useEffect(() => {
        checkAuthEnable();
    }, [checkBoxFirst, checkBoxSecond, fullName, canvasDone, canvasChanged])

    const dataURItoBlob = (dataURI) => {
            let byteString = atob(dataURI.split(",")[1]);
    
            let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    
            let ab = new ArrayBuffer(byteString.length);
            let ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
    
            return new Blob([ab], { type: mimeString });
        }
    
        const changeSignType = (e, v) => {
            setSignType(v);
            setFullName(v === "stylized" ? "" : fullName);
            setCanvasChanged(false);
            setCanvasDone(false);
        };
    
        const handleSignClear = () => {
            child.current.clearCanvas();
            setCanvasDone(false);
        };
    
        const handleSignDone = () => {
            child.current.cropImageFromCanvas();
            child.current.disableCanvas();
    
            setCanvasDone(true);
            setCanvasChanged(false);
            nameChangeHandler(fullName, fullName !== "");
            const img = child.current.convertCanvasToImage();
    
            setIsValidFullName(fullName === "" ? false : true);
    
            return img.src;
        };
    
        const uploadImage = async (file) => {
            setLoaderShow(true);
            let formData = new FormData();
            formData.append(
                "file",
                file,
                `${new Date().getTime()}.png`
            );
    
            await axios
                .post(configurations.baseUrl + "/employer/uploadEmployerImage", formData)
                .then((res) => {
                    setLoaderShow(false);
                    setImgUrl(res.data.response);
                    return res.data.response;
                });
        };
    
        const textSignatureToImage = () => {
            let node = document.getElementById("signTextContent");
            return html2canvas(node).then(function (canvas) {
                return canvas.toDataURL("image/png");
            });
        };
    
        const authorize = async () => {
            console.log('--------- brfore ----------');
            setLoaderShow(true);
    
            if (signType === "stylized") {
                const img = await textSignatureToImage();
                await uploadImage(dataURItoBlob(img));
            }
    
            if (signType === "scribble") {
                await uploadImage(dataURItoBlob(handleSignDone()));
            }
    
            // await uploadPDF()
    
            setLoaderShow(true);
            let data = {
                "empid": empDetails.empid,
                "authName": fullName,
                "esign": imgUrl,
                // "esignPdf": pdfUrl,
                "acknowledgement": true
            }
            axios.post(configurations.baseUrl + '/employer/updateEmployerAck', data)
                .then(response => {
                    console.log('empres', response);
                    if (response.data.code === 200) {
                        setLoaderShow(false);
                        setIsAcknowledged(true);
                    }
                })
        };
    
        const nameChangeHandler = (val, isValid, parentObj) => {
            if (isValid) {
                setFullName(val);
                setIsValidFullName(true);
            } else {
                setFullName("");
                setIsValidFullName(false);
            }
        };

    return (
        empDetails?.empid ?
        <div container style={{ display: 'flex', flexDirection: 'column', padding: 20, justifyContent: 'space-between' }}>
            <div>
                <Grid container>
                    <span>Please read and indicate your acceptance of the statements linked below. Then, when you’re ready, click SUBMIT.</span>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "5px" }} id="11">
                    <Grid item xs={2}>
                        <Checkbox
                            checked={checkBoxFirst}
                            inputProps={{
                                "aria-label": "secondary checkbox",
                            }}
                            style={{ color: "#533278", marginLeft: -12 }}
                            onClick={() => {
                                setCheckBoxFirst(!checkBoxFirst);
                            }}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        style={{
                            marginLeft: "30px",
                            marginTop: "-36px",
                            fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                        }}
                    >
                        <span>I CONFIRM that the billing account information, that I or a representative submitted to netWell is correct and that I authorize netWell to initiate debit entries from the account provided.</span>
                    </Grid>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "5px" }} id="11">
                    <Grid item xs={2}>
                        <Checkbox
                            checked={checkBoxSecond}
                            inputProps={{
                                "aria-label": "secondary checkbox",
                            }}
                            style={{ color: "#533278", marginLeft: -12 }}
                            onClick={() => {
                                setCheckBoxSecond(!checkBoxSecond);
                            }}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        style={{
                            marginLeft: "30px",
                            marginTop: "-36px",
                            fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                        }}
                    >
                        <span>I have READ, I UNDERSTAND, I ACKNOWLEDGE, I ACCEPT and I AGREE with the employer attestations and agreements on netWell programs and <a href={pdfLink} target='blank' style={{ color: "#2f3192" }}>Courtesy Payroll Deductions</a>.</span>
                    </Grid>
                </Grid>
            </div>
            <div style={{ marginTop: 35 }}>
                <Grid item xs={12} sm={6}>
                    <Typography
                        variant="h6"
                        component="h3"
                        style={customStyle.questionTitleText}
                    >
                        Authorization for employer
                    </Typography>
                    <SampleTextField
                        setChild={nameChangeHandler.bind(this)}
                        name={"FirstName"}
                        isValidFullName={isValidFullName}
                        reqFlag={true}
                        label={"Authorize this application by typing in your full name"}
                        value={fullName}
                        disable={false}
                        style={customStyle.textFieldN}
                        length={120}
                        fieldType={"holderName"}
                        errMsg={"Enter valid full name"}
                        helperMsg={
                            "By typing my name above, I understand and agree that this form of electronic signature has the same legal force and affect as a manual signature."
                        }
                        parentDetails={{ name: 'firstName' }}
                    ></SampleTextField>
                    <div>
                        <Typography
                            variant="h6"
                            component="h3"
                            style={customStyle.questionTitleText}
                        >
                            e-signature
                        </Typography>
                        <RadioGroup
                            row
                            aria-label="option"
                            name="row-radio-buttons-group"
                            value={signType}
                            onChange={(event, value) => {
                                changeSignType(event, value);
                            }}
                        >
                            <FormControlLabel
                                value="stylized"
                                control={<PurpleRadio />}
                                label="Use stylized script"
                            />
                            <FormControlLabel
                                value="scribble"
                                control={<PurpleRadio />}
                                label="Let me draw"
                            />
                        </RadioGroup>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            display: "block",
                        }}
                    >
                        {signType === "stylized" ? (
                            <>
                                <div id="txtsign" style={{ width: "100%", height: "100%" }}>
                                    <TextSignature
                                        id="textSignature"
                                        text={fullName}
                                        fontSize={50}
                                    />
                                </div>
                            </>
                        ) : (
                            <SignScroll
                                ref={child}
                                onCanvasChange={() =>
                                    setCanvasChanged(true)
                                }
                                onCanvasClear={() =>
                                    setCanvasChanged(false)
                                }
                            />
                        )}
                    </div>
                    {signType !== "stylized" ? (
                        <div>
                            <NextButton
                                variant="contained"
                                style={customStyle.viewProgSum}
                                onClick={() => {
                                    handleSignClear();
                                    setCanvasChanged(false);
                                }}
                                disabled={canvasChanged ? false : true}
                            >
                                CLEAR
                            </NextButton>

                            <NextButton
                                variant="contained"
                                style={customStyle.viewProgSum}
                                onClick={() => handleSignDone()}
                                disabled={canvasChanged ? false : true}
                            >
                                DONE
                            </NextButton>
                        </div>
                    ) : (
                        <></>
                    )}
                </Grid>
                <Grid xl={2} lg={4} md={5} sm={6} xs={8} item={true} style={customStyle.EnrollNew2Visit}>
                    <NextButton style={{ margin: '0', backgroundColor: disableAuthSubmit ? '#f8f8f8' : '#2f3192', margin: '35px 10px 0px 0px', width: '120px', height: '40px', color: disableAuthSubmit ? '#000' : '#fff' }} disabled={disableAuthSubmit} onClick={() => authorize()}>SUBMIT</NextButton>
                </Grid>
            </div>
        </div>
        :
        <ShimmerDashboard />
    )
}

export default SignForm
